import { useState } from 'react'
import { useAtomValue } from 'jotai'
import { Navigate } from 'react-router-dom'
import { AxiosError } from 'axios'
import { isAuthenticatedAtom } from '@app/state/authAtom'
import { getCurrentSubdomain } from '@app/utils/getCurrentSubdomain'
import { appLink } from '@app/config/appLink'
import AuthService from '@app/services/authService'

// TEMPORARY - quick sketch for the marketing campaign invite link
export function SignupCampaignPage() {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom)
  const [email, setEmail] = useState(
    () => new URLSearchParams(window.location.search).get('email') ?? '',
  )
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  if (isAuthenticated) {
    return <Navigate to={appLink.homepage.path} replace />
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError(null)
    setSubmitting(true)
    try {
      const { redirectUrl } = await AuthService.signup({ email })
      window.location.href = redirectUrl
    } catch (err) {
      const isClientError =
        err instanceof AxiosError &&
        err.response &&
        err.response.status >= 400 &&
        err.response.status < 500
      const message = isClientError ? err.response?.data?.error : undefined
      setError(message || 'Something went wrong, please try again.')
      setSubmitting(false)
    }
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-6 px-6 text-center text-white bg-brand-navy">
      <img src="/website/rex_logo.png" className="w-auto h-16" alt="Resilience Explorer" />
      <h1 className="text-3xl font-semibold sm:text-5xl">
        You&apos;re invited to Resilience Explorer®
      </h1>
      <p className="max-w-xl text-white/80">
        Resilience Explorer® turns data and evidence into shared, continuously updated natural
        hazard and climate risk intelligence to drive decisions. See how your organisation can move
        from risk visibility to risk-informed decisions.
      </p>

      <form onSubmit={handleSubmit} className="flex flex-col items-center w-full max-w-sm gap-3">
        <input
          type="email"
          name="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@company.com"
          className="w-full px-4 py-3 text-sm text-black bg-white rounded outline-none"
        />
        <button
          type="submit"
          disabled={submitting}
          className="w-full px-8 py-3 text-sm font-semibold text-white no-underline transition-colors rounded cursor-pointer bg-brand-blue hover:bg-brand-navy disabled:opacity-50"
        >
          {submitting ? 'Signing up...' : 'Sign Up'}
        </button>
        {error && <p className="text-sm font-semibold text-red-400">{error}</p>}
      </form>
    </div>
  )
}
